import React from 'react';
import { AtSignIcon, FacebookIcon, MailIcon } from 'lucide-react';
const links = [{
  icon: MailIcon,
  label: 'tuconexioneducativa@gmail.com',
  href: 'mailto:tuconexioneducativa@gmail.com'
}, {
  icon: AtSignIcon,
  label: 'Instagram: @Tuconexioneducativa',
  href: 'https://instagram.com/tuconexioneducativa'
}, {
  icon: FacebookIcon,
  label: 'Facebook: Tuconexioneducativa',
  href: 'https://facebook.com/tuconexioneducativa'
}];
export function Footer() {
  return <footer className="bg-night pb-28 lg:pb-14" data-id="element-93" data-mp="37o6cv1anxdd">
      <div className="mx-auto max-w-content px-6 pt-14" data-id="element-94" data-mp="36d3cxfoatnb">
        <p className="mx-auto max-w-lg text-center font-display text-2xl leading-snug text-gold-soft" data-id="element-95" data-mp="3ldkdj3f9yapl">
          “La próxima lectura puede cambiar tu fe completamente.”
        </p>

        <div className="mt-10 flex flex-col items-center gap-6 border-t border-night-line pt-8 md:flex-row md:justify-between" data-id="element-96" data-mp="29yxdbdsefmmc">
          <ul className="flex flex-col items-center gap-3 font-sans text-sm md:flex-row md:gap-8" data-id="element-97" data-mp="2ezuvhqdesgnu">
            {links.map(link => <li key={link.label} data-id="element-98" data-mp="3gagz5ny8f937">
                <a href={link.href} className="inline-flex items-center gap-2 text-parchment/70 transition-colors duration-150 ease-out hover:text-gold-soft" data-id="element-99" data-mp="3gb8s0r0g2sps">
                  <link.icon className="h-4 w-4" aria-hidden="true" data-id="element-100" data-mp="3q7u1ppnesrzy" />
                  {link.label}
                </a>
              </li>)}
          </ul>

          <p className="text-center font-sans text-xs leading-relaxed text-parchment/45 md:text-right" data-id="element-101" data-mp="34gwrh0rwr7l">
            © GPS Bíblico™ 2026 — Todos los derechos reservados.
            <br data-id="element-102" data-mp="huo5v64w4xvm" />
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}